<template>
  <div class="StartDietPlan">
      <app-header></app-header>
	  <div class="page-wrapper">
			<div class="MenoCard">
				
			</div>
			<div style="padding-bottom:30px;margin-left: 0px;margin-right: 0px;" class="panel panel-default card-view">
					<div class="panel-heading">
						<div class="text-center">
							<h5 class="panel-title txt-light">Start a diet plan</h5>
						</div>
						<div class="clearfix"></div>
					</div>
					<div id="collapse_1" class="panel-wrapper collapse in">
						<div class="container">
							<p class="pt-5 mt-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
								Phasellus in mi dapibus, semper elit porttitor, lacinia leo. 
								Nulla malesuada, ipsum sed malesuada faucibus, nulla tellus commodo nisi, et convallis ipsum velit id nisl. 
								Curabitur eget mi finibus, maximus enim nec, mattis leo. Donec tristique ante tortor, et venenatis tellus rutrum sit amet. 
								Maecenas sit amet accumsan neque. Nunc fringilla vitae quam eu fringilla. Nullam in enim in ante mattis fermentum. Integer convallis ullamcorper hendrerit. 
								Nam tincidunt felis erat, ut mattis turpis dignissim pretium. Proin commodo, libero efficitur ullamcorper blandit, quam sapien porta felis, et auctor justo tortor sed felis. 
								Morbi nec urna laoreet, imperdiet eros at, aliquam nibh. Morbi egestas nibh risus, vitae accumsan massa iaculis sed.
							</p>
							<p class="pt-5 mt-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
								Phasellus in mi dapibus, semper elit porttitor, lacinia leo. 
								Nulla malesuada, ipsum sed malesuada faucibus, nulla tellus commodo nisi, et convallis ipsum velit id nisl. 
								Curabitur eget mi finibus, maximus enim nec, mattis leo. Donec tristique ante tortor, et venenatis tellus rutrum sit amet. 
								Maecenas sit amet accumsan neque. Nunc fringilla vitae quam eu fringilla. Nullam in enim in ante mattis fermentum. Integer convallis ullamcorper hendrerit. 
								Nam tincidunt felis erat, ut mattis turpis dignissim pretium. Proin commodo, libero efficitur ullamcorper blandit, quam sapien porta felis, et auctor justo tortor sed felis. 
								Morbi nec urna laoreet, imperdiet eros at, aliquam nibh. Morbi egestas nibh risus, vitae accumsan massa iaculis sed.
							</p>	
						</div>
						<div style="margin-top:20px;" class="container">
							<div class="row">	
								<div class="col-md-12 text-center dietButton">
									<a href="#" @click="$router.push('/food-tracker?meal=1')" data-target="#mealPlanModal" class="btn btn-nutri-green buttonMeno">
										<span class="btn-text">Start a diet plan</span>
									</a>
								</div>	
							</div>	
						</div>	
					</div>
                    <div id="mealPlanModal" class="modal fade text-center">
                        <div class="modal-dialog">
                            <div class="modal-content">
                            </div>
                        </div>
                    </div> 
			</div>
		</div>
      <app-footer></app-footer>  
  </div>
</template>




<script>
	import API from "../../services/api.js";
	import AppFooter from '../../components/common/AppFooter.vue'
	import AppHeader from '../../components/common/AppHeader.vue'

	const api = new API();

	export default {
		data() {
			return {
			}
		},
		components: {
			AppHeader,
			AppFooter,
		},
		methods:{
		recommendedIntakeCalculation() {
			api.recommendedIntakeCalculation(profile).then(async response => {
				if (response.data.success) {
					
				}
			});
    	},
			
		},
		mounted: function () {
	
		}
	}
</script>

<style>
.MenoCard{
	margin-top: -10px;
	background-image: url("https://s3.us-east-2.amazonaws.com/loopdigital-nutrivitas/webapp/Login-BG.jpg");
	background-size: cover;
	height: 50vh;
}

.buttonMeno{
	width: 50%;
	margin-top: 4%;
}

.dietButton{
    padding-bottom: 20px;
}


</style>


// WEBPACK FOOTER //
// src/views/Diet/StartDietPlan.vue